import React, { useEffect, useState } from "react";
import { Logo, MenuIconWhiteSvg, MenuIconBlackSvg } from "../../images/Svgs";
import { useNavigate, useLocation, useParams } from "react-router";

const Siderbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("dashboard");
  const checkRole = JSON.parse(localStorage.getItem("userDetail"));
  let path = location.pathname;
  const id = useParams();
  useEffect(() => {
    if (path === "/dashboard") {
      setActiveMenu("dashboard");
    }
    if (path === "/events") {
      setActiveMenu("events");
    }
    if (path === `/events/${id?.id}`) {
      setActiveMenu("events");
    }
    if (path === "/event-logistics") {
      setActiveMenu("event-logistics");
    }
    if (path === "/user-management") {
      setActiveMenu("user-management");
    }
    if (path === "/transactions") {
      setActiveMenu("transactions");
    }
    if (path === "/legal-information") {
      setActiveMenu("legal-information");
    }
  }, [location]);

  const handleMenuClick = (value, url) => {
    setActiveMenu(value);
    navigate(url);
  };
  const Menus = [
    {
      role_id: 2,
      title: "Dashboard",
      url: "dashboard",
    },
    {
      role_id: 1,
      title: "Events",
      url: "events",
    },
    {
      role_id: 2,
      title: "Event Logistics",
      url: "event-logistics",
    },
    {
      role_id: 1,
      title: "User Management",
      url: "user-management",
    },
    {
      role_id: 1,
      title: "Transactions",
      url: "transactions",
    },
    {
      role_id: 1,
      title: "Legal Information",
      url: "legal-information",
    },
  ];
  // filter menuse on the basis of user role
  const filteredMenus = Menus.filter((elem) => {
    if (checkRole?.role_id === 1) {
      return true;
    } else if (checkRole?.role_id === 2) {
      return elem?.role_id === 2;
    }
    return false;
  });

  return (
    <div
      id="mySidebar"
      class={`sidebar ${isSidebarOpen ? "open-sidebar" : "close-bar"}`}
     
    >
      <div class="menu-sec">
        <ul>
          {filteredMenus &&
            filteredMenus?.map((ele) => (
              <li>
                <a
                  // href="#"
                  className={`${activeMenu === `${ele.url}` ? "active" : ""}`}
                  onClick={() => handleMenuClick(`${ele.url}`, `/${ele.url}`)}
                >
                  <div>{ele?.title}</div>
                  <div>
                    {activeMenu === `${ele.url}` ? (
                      <MenuIconWhiteSvg />
                    ) : (
                      <MenuIconBlackSvg />
                    )}
                  </div>
                </a>
              </li>
            ))}
          {/* <li>
            <a
              // href="#"
              className={`${activeMenu === "events" ? "active" : ""}`}
              onClick={() => handleMenuClick("events", "/events")}
            >
              <div>Events</div>
              <div>
                {activeMenu === "events" ? (
                  <MenuIconWhiteSvg />
                ) : (
                  <MenuIconBlackSvg />
                )}
              </div>
            </a>
          </li>
          <li>
            <a
              // href="#"
              className={`${activeMenu === "event_logistics" ? "active" : ""}`}
              onClick={() =>
                handleMenuClick("event_logistics", "/event-logistics")
              }
            >
              <div>Event Logistics</div>
              <div>
                {activeMenu === "event_logistics" ? (
                  <MenuIconWhiteSvg />
                ) : (
                  <MenuIconBlackSvg />
                )}
              </div>
            </a>
          </li>
          <li>
            <a
              // href="#"
              className={`${activeMenu === "user_management" ? "active" : ""}`}
              onClick={() =>
                handleMenuClick("user_management", "/user-management")
              }
            >
              <div>User Management</div>
              <div>
                {activeMenu === "user_management" ? (
                  <MenuIconWhiteSvg />
                ) : (
                  <MenuIconBlackSvg />
                )}
              </div>
            </a>
          </li>
          <li>
            <a
              // href="#"
              className={`${activeMenu === "transaction" ? "active" : ""}`}
            //   onClick={() =>
            //     handleMenuClick("user_management", "/user-management")
            //   }
            >
              <div>Transactions</div>
              <div>
                {activeMenu === "user_management" ? (
                  <MenuIconWhiteSvg />
                ) : (
                  <MenuIconBlackSvg />
                )}
              </div>
            </a>
          </li> */}
        </ul>
      </div>
    </div>
  );
};
export default Siderbar;
